var $38del$react = require("react");
var $38del$reactjsxruntime = require("react/jsx-runtime");
var $38del$styledcomponents = require("styled-components");
var $38del$reactrouterdom = require("react-router-dom");
var $38del$muimaterialCircularProgress = require("@mui/material/CircularProgress");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function get() {
        return $b442c3b93ad7ae60$exports.Link;
    }
});
var $b442c3b93ad7ae60$exports = {};
"use strict";
function $b442c3b93ad7ae60$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b442c3b93ad7ae60$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b442c3b93ad7ae60$var$_typeof(o);
}
Object.defineProperty($b442c3b93ad7ae60$exports, "__esModule", {
    value: true
});
$b442c3b93ad7ae60$exports.Link = void 0;
var $0d9013960a986d40$exports = {};
"use strict";
Object.defineProperty($0d9013960a986d40$exports, "__esModule", {
    value: true
});
Object.defineProperty($0d9013960a986d40$exports, "LinkArrowIcon", {
    enumerable: true,
    get: function get() {
        return $9079cda4e96743e2$exports.LinkArrowIcon;
    }
});
var $9079cda4e96743e2$exports = {};
"use strict";
Object.defineProperty($9079cda4e96743e2$exports, "__esModule", {
    value: true
});
$9079cda4e96743e2$exports.LinkArrowIcon = void 0;

var $9079cda4e96743e2$var$_react = $9079cda4e96743e2$var$_interopRequireDefault($38del$react);


var $9079cda4e96743e2$var$_mask;
function $9079cda4e96743e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9079cda4e96743e2$var$LinkArrowIcon = $9079cda4e96743e2$exports.LinkArrowIcon = function LinkArrowIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "p500" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 10 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 8 : _ref$height;
    var theme = (0, $38del$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $38del$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 10 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            $9079cda4e96743e2$var$_mask || ($9079cda4e96743e2$var$_mask = /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("mask", {
                id: "path-1-inside-1_5014_436",
                fill: "white",
                children: /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("path", {
                    d: "M6.73388 0.605275C6.59765 0.464908 6.37091 0.464908 6.22991 0.605275C6.09368 0.7409 6.09368 0.966625 6.22991 1.10193L8.78533 3.64592H0.35281C0.15624 3.64624 0 3.80178 0 3.99747C0 4.19316 0.15624 4.35376 0.35281 4.35376H8.78533L6.22991 6.89301C6.09368 7.03338 6.09368 7.25942 6.22991 7.39473C6.37091 7.53509 6.59797 7.53509 6.73388 7.39473L9.89425 4.24849C10.0352 4.11286 10.0352 3.88714 9.89425 3.75183L6.73388 0.605275Z"
                })
            })),
            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("path", {
                d: "M6.73388 0.605275C6.59765 0.464908 6.37091 0.464908 6.22991 0.605275C6.09368 0.7409 6.09368 0.966625 6.22991 1.10193L8.78533 3.64592H0.35281C0.15624 3.64624 0 3.80178 0 3.99747C0 4.19316 0.15624 4.35376 0.35281 4.35376H8.78533L6.22991 6.89301C6.09368 7.03338 6.09368 7.25942 6.22991 7.39473C6.37091 7.53509 6.59797 7.53509 6.73388 7.39473L9.89425 4.24849C10.0352 4.11286 10.0352 3.88714 9.89425 3.75183L6.73388 0.605275Z",
                fill: "white",
                stroke: color,
                strokeWidth: "2",
                mask: "url(#path-1-inside-1_5014_436)"
            })
        ]
    });
};





var $b442c3b93ad7ae60$var$_react = $b442c3b93ad7ae60$var$_interopRequireWildcard($38del$react);
var $f9632f2100351f18$exports = {};
"use strict";
Object.defineProperty($f9632f2100351f18$exports, "__esModule", {
    value: true
});
$f9632f2100351f18$exports.normalize = $f9632f2100351f18$exports.isUrl = void 0;
var $f9632f2100351f18$var$IS_URL = /^https?:\/\//i;
var $f9632f2100351f18$var$isUrl = $f9632f2100351f18$exports.isUrl = function isUrl(urlString) {
    return $f9632f2100351f18$var$IS_URL.test(urlString);
};
var $f9632f2100351f18$var$normalize = $f9632f2100351f18$exports.normalize = function normalize(input) {
    return input.replace(/^0+(?=\d)/, "");
};


var $e8fbf71c9f7d0aaa$exports = {};
"use strict";
function $e8fbf71c9f7d0aaa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e8fbf71c9f7d0aaa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8fbf71c9f7d0aaa$var$_typeof(o);
}
Object.defineProperty($e8fbf71c9f7d0aaa$exports, "__esModule", {
    value: true
});
$e8fbf71c9f7d0aaa$exports.StopColorVariant = $e8fbf71c9f7d0aaa$exports.ProgressIcon = $e8fbf71c9f7d0aaa$exports.LinkBase = $e8fbf71c9f7d0aaa$exports.ColorVariant = $e8fbf71c9f7d0aaa$exports.A = void 0;
var $ad4dca288ee730e4$exports = {};
"use strict";
Object.defineProperty($ad4dca288ee730e4$exports, "__esModule", {
    value: true
});
Object.defineProperty($ad4dca288ee730e4$exports, "GradientCircularProgress", {
    enumerable: true,
    get: function get() {
        return $8bc7fdabeb957de2$exports.GradientCircularProgress;
    }
});
var $8bc7fdabeb957de2$exports = {};
"use strict";
Object.defineProperty($8bc7fdabeb957de2$exports, "__esModule", {
    value: true
});
$8bc7fdabeb957de2$exports.GradientCircularProgress = void 0;


var $8bc7fdabeb957de2$var$_CircularProgress = $8bc7fdabeb957de2$var$_interopRequireDefault($38del$muimaterialCircularProgress);
var $243a973d46cd50df$exports = {};
"use strict";
Object.defineProperty($243a973d46cd50df$exports, "__esModule", {
    value: true
});
$243a973d46cd50df$exports.Wrapper = void 0;

var $243a973d46cd50df$var$_styledComponents = $243a973d46cd50df$var$_interopRequireDefault($38del$styledcomponents);
var $243a973d46cd50df$var$_templateObject;
function $243a973d46cd50df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $243a973d46cd50df$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $243a973d46cd50df$var$Wrapper = $243a973d46cd50df$exports.Wrapper = $243a973d46cd50df$var$_styledComponents["default"].div($243a973d46cd50df$var$_templateObject || ($243a973d46cd50df$var$_templateObject = $243a973d46cd50df$var$_taggedTemplateLiteral([
    "\n  position: relative;\n  height: 14px;\n  width: 14px;\n"
])));



function $8bc7fdabeb957de2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $8bc7fdabeb957de2$var$GradientCircularProgress = $8bc7fdabeb957de2$exports.GradientCircularProgress = function GradientCircularProgress(props) {
    var className = props.className, _props$startColor = props.startColor, startColor = _props$startColor === void 0 ? "p500" : _props$startColor, _props$stopColor = props.stopColor, stopColor = _props$stopColor === void 0 ? "p600" : _props$stopColor;
    var theme = (0, $38del$styledcomponents.useTheme)();
    return /*#__PURE__*/ (0, $38del$reactjsxruntime.jsxs)($243a973d46cd50df$exports.Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("svg", {
                width: 0,
                height: 0,
                children: /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $38del$reactjsxruntime.jsxs)("linearGradient", {
                        id: "my_gradient",
                        x1: "0%",
                        y1: "0%",
                        x2: "0%",
                        y2: "100%",
                        children: [
                            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("stop", {
                                offset: "0%",
                                stopColor: theme.color[startColor]
                            }),
                            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("stop", {
                                offset: "100%",
                                stopColor: theme.color[stopColor]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($8bc7fdabeb957de2$var$_CircularProgress["default"], {
                variant: "determinate",
                sx: {
                    color: theme.color[startColor],
                    position: "absolute"
                },
                size: 14,
                thickness: 8,
                value: 100
            }),
            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($8bc7fdabeb957de2$var$_CircularProgress["default"], {
                variant: "indeterminate",
                sx: {
                    "svg circle": {
                        stroke: "url(#my_gradient)"
                    },
                    position: "absolute",
                    left: 0,
                    top: 0
                },
                size: 14,
                thickness: 8,
                value: 100
            })
        ]
    });
};






var $e8fbf71c9f7d0aaa$var$_styledComponents = $e8fbf71c9f7d0aaa$var$_interopRequireWildcard($38del$styledcomponents);
var $e8fbf71c9f7d0aaa$var$_templateObject, $e8fbf71c9f7d0aaa$var$_templateObject2, $e8fbf71c9f7d0aaa$var$_templateObject3, $e8fbf71c9f7d0aaa$var$_templateObject4;
function $e8fbf71c9f7d0aaa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e8fbf71c9f7d0aaa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e8fbf71c9f7d0aaa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e8fbf71c9f7d0aaa$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e8fbf71c9f7d0aaa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e8fbf71c9f7d0aaa$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $e8fbf71c9f7d0aaa$var$ColorVariant = $e8fbf71c9f7d0aaa$exports.ColorVariant = {
    primary: "p500",
    secondary: "g500"
};
var $e8fbf71c9f7d0aaa$var$StopColorVariant = $e8fbf71c9f7d0aaa$exports.StopColorVariant = {
    primary: "p600",
    secondary: "g600"
};
var $e8fbf71c9f7d0aaa$var$styles = (0, $e8fbf71c9f7d0aaa$var$_styledComponents.css)($e8fbf71c9f7d0aaa$var$_templateObject || ($e8fbf71c9f7d0aaa$var$_templateObject = $e8fbf71c9f7d0aaa$var$_taggedTemplateLiteral([
    "\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  ",
    "\n  ",
    "\n    text-decoration: none;\n\n  span {\n    text-decoration: ",
    ";\n  }\n\n  &:hover {\n    span {\n      text-decoration: underline;\n    }\n  }\n\n  color: ",
    ";\n\n  ",
    "\n\n  &:hover {\n    color: ",
    ";\n  }\n\n  svg {\n    margin-left: 4px;\n  }\n"
])), function(props) {
    return props.$type === "small" ? props.theme.typo.displayXXS : props.theme.typo.displayXS;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.$underline ? "underline" : "none";
}, function(props) {
    return props.theme.color[$e8fbf71c9f7d0aaa$var$ColorVariant[props.$variant]];
}, function(props) {
    return props.$loading && "\n    color: ".concat(props.theme.color[$e8fbf71c9f7d0aaa$var$StopColorVariant[props.$variant]], ";\n    ");
}, function(props) {
    return props.theme.color[$e8fbf71c9f7d0aaa$var$StopColorVariant[props.$variant]];
});
var $e8fbf71c9f7d0aaa$var$A = $e8fbf71c9f7d0aaa$exports.A = $e8fbf71c9f7d0aaa$var$_styledComponents["default"].a($e8fbf71c9f7d0aaa$var$_templateObject2 || ($e8fbf71c9f7d0aaa$var$_templateObject2 = $e8fbf71c9f7d0aaa$var$_taggedTemplateLiteral([
    "\n  ",
    "\n"
])), $e8fbf71c9f7d0aaa$var$styles);
var $e8fbf71c9f7d0aaa$var$LinkBase = $e8fbf71c9f7d0aaa$exports.LinkBase = (0, $e8fbf71c9f7d0aaa$var$_styledComponents["default"])($38del$reactrouterdom.Link)($e8fbf71c9f7d0aaa$var$_templateObject3 || ($e8fbf71c9f7d0aaa$var$_templateObject3 = $e8fbf71c9f7d0aaa$var$_taggedTemplateLiteral([
    "\n  ",
    "\n"
])), $e8fbf71c9f7d0aaa$var$styles);
var $e8fbf71c9f7d0aaa$var$ProgressIcon = $e8fbf71c9f7d0aaa$exports.ProgressIcon = (0, $e8fbf71c9f7d0aaa$var$_styledComponents["default"])($ad4dca288ee730e4$exports.GradientCircularProgress)($e8fbf71c9f7d0aaa$var$_templateObject4 || ($e8fbf71c9f7d0aaa$var$_templateObject4 = $e8fbf71c9f7d0aaa$var$_taggedTemplateLiteral([
    "\n  margin-left: 4px;\n\n  svg {\n    margin: 0px;\n  }\n"
])));


var $41d1c8a71df4b3cc$exports = {};
"use strict";
Object.defineProperty($41d1c8a71df4b3cc$exports, "__esModule", {
    value: true
});
$41d1c8a71df4b3cc$exports.toggleHover = void 0;
var $41d1c8a71df4b3cc$var$toggleHover = $41d1c8a71df4b3cc$exports.toggleHover = function toggleHover(_ref) {
    var setHover = _ref.setHover, hover = _ref.hover;
    return function() {
        return setHover(hover);
    };
};



var $b442c3b93ad7ae60$var$_excluded = [
    "type",
    "variant",
    "underline",
    "showIcon",
    "Icon",
    "loading",
    "children",
    "to",
    "target",
    "isHover"
];
function $b442c3b93ad7ae60$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b442c3b93ad7ae60$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b442c3b93ad7ae60$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b442c3b93ad7ae60$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b442c3b93ad7ae60$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b442c3b93ad7ae60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b442c3b93ad7ae60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b442c3b93ad7ae60$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b442c3b93ad7ae60$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b442c3b93ad7ae60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b442c3b93ad7ae60$var$_defineProperty(e, r, t) {
    return (r = $b442c3b93ad7ae60$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b442c3b93ad7ae60$var$_toPropertyKey(t) {
    var i = $b442c3b93ad7ae60$var$_toPrimitive(t, "string");
    return "symbol" == $b442c3b93ad7ae60$var$_typeof(i) ? i : i + "";
}
function $b442c3b93ad7ae60$var$_toPrimitive(t, r) {
    if ("object" != $b442c3b93ad7ae60$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b442c3b93ad7ae60$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b442c3b93ad7ae60$var$_slicedToArray(r, e) {
    return $b442c3b93ad7ae60$var$_arrayWithHoles(r) || $b442c3b93ad7ae60$var$_iterableToArrayLimit(r, e) || $b442c3b93ad7ae60$var$_unsupportedIterableToArray(r, e) || $b442c3b93ad7ae60$var$_nonIterableRest();
}
function $b442c3b93ad7ae60$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b442c3b93ad7ae60$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b442c3b93ad7ae60$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b442c3b93ad7ae60$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b442c3b93ad7ae60$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b442c3b93ad7ae60$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b442c3b93ad7ae60$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $b442c3b93ad7ae60$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b442c3b93ad7ae60$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b442c3b93ad7ae60$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b442c3b93ad7ae60$var$Link = $b442c3b93ad7ae60$exports.Link = function Link(props) {
    var _props$type = props.type, type = _props$type === void 0 ? "small" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "primary" : _props$variant, underline = props.underline, showIcon = props.showIcon, Icon = props.Icon, loading = props.loading, children = props.children, _props$to = props.to, to = _props$to === void 0 ? "" : _props$to, target = props.target, _props$isHover = props.isHover, isHover = _props$isHover === void 0 ? false : _props$isHover, rest = $b442c3b93ad7ae60$var$_objectWithoutProperties(props, $b442c3b93ad7ae60$var$_excluded);
    var _useState = (0, $b442c3b93ad7ae60$var$_react.useState)(isHover), _useState2 = $b442c3b93ad7ae60$var$_slicedToArray(_useState, 2), hover = _useState2[0], setHover = _useState2[1];
    var isExternalLink = (0, $f9632f2100351f18$exports.isUrl)(to) || to.startsWith("mailto:") || to.startsWith("tel:");
    var content = /*#__PURE__*/ (0, $38del$reactjsxruntime.jsxs)($38del$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)("span", {
                children: children
            }),
            showIcon && !loading && (Icon && /*#__PURE__*/ (0, $b442c3b93ad7ae60$var$_react.isValidElement)(Icon) ? /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)(Icon.type, $b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread({}, Icon.props), {}, {
                colorCode: hover ? $e8fbf71c9f7d0aaa$exports.StopColorVariant[variant] : $e8fbf71c9f7d0aaa$exports.ColorVariant[variant]
            })) : /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($0d9013960a986d40$exports.LinkArrowIcon, {
                className: "icon",
                colorCode: hover ? $e8fbf71c9f7d0aaa$exports.StopColorVariant[variant] : $e8fbf71c9f7d0aaa$exports.ColorVariant[variant]
            })),
            loading && /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($e8fbf71c9f7d0aaa$exports.ProgressIcon, {
                startColor: $e8fbf71c9f7d0aaa$exports.ColorVariant[variant],
                stopColor: $e8fbf71c9f7d0aaa$exports.StopColorVariant[variant]
            })
        ]
    });
    var commonProps = {
        $variant: variant,
        $type: type,
        $underline: underline,
        $loading: loading,
        onMouseEnter: (0, $41d1c8a71df4b3cc$exports.toggleHover)({
            setHover: setHover,
            hover: true
        }),
        onMouseLeave: (0, $41d1c8a71df4b3cc$exports.toggleHover)({
            setHover: setHover,
            hover: false
        })
    };
    if (isExternalLink) return /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($e8fbf71c9f7d0aaa$exports.A, $b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread({
        href: to,
        target: target
    }, rest), commonProps), {}, {
        children: content
    }));
    if (!to) return /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($e8fbf71c9f7d0aaa$exports.A, $b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread({}, rest), commonProps), {}, {
        children: content
    }));
    return /*#__PURE__*/ (0, $38del$reactjsxruntime.jsx)($e8fbf71c9f7d0aaa$exports.LinkBase, $b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread($b442c3b93ad7ae60$var$_objectSpread({
        to: to
    }, rest), commonProps), {}, {
        children: content
    }));
};




//# sourceMappingURL=index.js.map
